<template>
  <div class="add__user">
    <v-dialog v-model="show" max-width="800px" persistent>
      <v-card>
        <v-toolbar>
          <v-btn icon @click="close" :disabled="progress">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ title }}: {{ values.name }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- <v-btn @click="save"> <v-icon left>save</v-icon>Записать </v-btn> -->
        </v-toolbar>
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-text-field
              :rules="rules.emailRules"
              prepend-icon="email"
              type="email"
              required
              label="Логин (изменить потом нельзя)"
              v-model="values.email"
              :readonly="readonly"
            />

            <v-row>
              <v-col cols="4" class="pt-1 pb-1">
                <v-text-field
                  :rules="rules.nameRules"
                  required
                  label="*Фамилия"
                  v-model="values.famil"
                  :readonly="readonly"
                />
              </v-col>
              <v-col cols="4" class="pt-1 pb-1">
                <v-text-field
                  :rules="rules.nameRules"
                  required
                  label="*Имя"
                  v-model="values.name"
                  :readonly="readonly"
                />
              </v-col>
              <v-col cols="4" class="pt-1 pb-1">
                <v-text-field
                  label="Отчество"
                  v-model="values.otch"
                  :readonly="readonly"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6" class="pt-1 pb-1">
                <v-text-field
                  placeholder="(xxx)xxx xx xx"
                  prepend-icon="phone"
                  v-mask="rules.phonemask"
                  prefix="+7"
                  :rules="rules.phoneRules"
                  label="*№ телефона"
                  v-model="values.phone"
                  :readonly="readonly"
                />
              </v-col>
              <v-col cols="6" class="pt-1 pb-1">
                <v-text-field
                  label="Должность"
                  v-model="values.position"
                  :readonly="readonly"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="pt-1 pb-1">
                <v-select
                  v-model="values.role"
                  :items="roles"
                  item-text="name"
                  item-value="role"
                  label="Роль"
                  required
                  :rules="rules.emptyRules"
                  :readonly="
                    role() === roleObj.bank ||
                    role() === roleObj.agregator ||
                    readonly
                      ? true
                      : false
                  "
                />
              </v-col>
            </v-row>
            <v-row v-if="values.role === 'bank' || values.role === 'bankAdmin'">
              <v-col cols="12" v-if="checkRole(roleObj.bankir)">
                <v-select
                  v-model="values.bank"
                  :items="product.banks"
                  label="Банк"
                  item-text="name"
                  item-value="id"
                  :readonly="readonly"
                />
                <Website
                  :sortList="getBankWebsite(product.banks, values.bank)"
                  v-model="values.website"
                  :readonly="readonly"
                  v-if="values.bank"
                />
              </v-col>
              <v-col cols="12" v-else-if="checkRole(roleObj.bankAdmin)">
                <v-select
                  :value="values.bank"
                  :items="product2.banks"
                  label="Банк"
                  item-text="name"
                  item-value="id"
                  readonly
                />
                <Website
                  :sortList="getBankWebsite(product.banks, values.bank)"
                  v-model="values.website"
                  :readonly="readonly"
                  v-if="values.bank"
                />
              </v-col>
              <v-col cols="12" v-else>
                <v-select
                  :value="values.bank"
                  :items="product2.banks"
                  label="Банк"
                  item-text="name"
                  item-value="id"
                  readonly
                />
                <Website
                  :sortList="getBankWebsite(product.banks, values.bank)"
                  v-model="values.website"
                  readonly
                  v-if="values.bank"
                />
              </v-col>
            </v-row>
            <v-row
              v-if="
                values.role === 'agregator' || values.role === 'agregatorAdmin'
              "
            >
              <v-col cols="12" v-if="checkRole(roleObj.bankir)">
                <Website
                  v-model="values.website"
                  :multiple="false"
                  :readonly="readonly"
                />
                <v-select
                  v-model="values.bank"
                  :items="product2.banks"
                  label="Банк"
                  item-text="name"
                  item-value="id"
                  multiple
                  :readonly="readonly"
                  v-if="values.website"
                />
              </v-col>
              <v-col cols="12" v-else-if="checkRole(roleObj.agregatorAdmin)">
                <!-- :sortList="product.banks" -->
                <Website v-model="values.website" :multiple="false" readonly />
                <v-select
                  :value="values.bank"
                  :items="product2.banks"
                  label="Банк"
                  item-text="name"
                  item-value="id"
                  multiple
                  :readonly="readonly"
                  v-if="values.website"
                />
              </v-col>
              <v-col cols="12" v-else>
                <!-- :sortList="product2.banks" -->
                <Website v-model="values.website" readonly :multiple="false" />
                <v-select
                  :value="values.bank"
                  :items="product2.banks"
                  label="Банк"
                  item-text="name"
                  item-value="id"
                  readonly
                  multiple
                  v-if="values.website"
                />
              </v-col>
            </v-row>
            <v-row v-if="values.role === 'bank' || values.role === 'agregator'">
              <v-col cols="12">
                <v-checkbox
                  label="Только чтение"
                  v-model="values.onlyRead"
                  class="check"
                  :readonly="readonly"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close" :disabled="progress">Отмена (закрыть)</v-btn>
          <v-btn @click="save" :disabled="progress" :loading="progress"
            >Записать</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Globalrules from "./api/rules";
import Swal from "sweetalert2";
import Website from "@/views/calcsettings/components/website.vue";
import { roleObj } from "@/plugins/roles";

export default {
  name: "add_or_edit_user",
  components: {
    Website,
  },
  data: () => ({
    roleObj,
    rules: Globalrules,
    valid: true,
    progress: false,
    product2: null,
  }),
  props: {
    show: { type: Boolean, default: false },
    edit: { type: Boolean, default: false },
    value: {},
    title: { type: String, default: "Добавить пользователя" },
    readonly: { type: Boolean, default: false },
  },
  methods: {
    clearBtn(interval) {
      this.saveBtnText = "Записать";
      clearInterval(interval);
    },
    makeGoodField(val) {
      if (!val) return "";
      else return val;
    },
    async save() {
      let data = null;
      // console.log("this.edit", this.edit);
      if (!this.edit) {
        this.progress = true;
        const clearInter = setInterval(
          () => (this.saveBtnText = `${this.saveBtnText} ` + "."),
          500
        );
        if (!this.$refs.form.validate()) {
          Swal.fire({
            icon: "error",
            title: "Не все поля заполнены правильно",
            text: "Проверьте правильность заполнения обязательных полей",
          });
          this.progress = false;
          this.clearBtn(clearInter);
          return;
        }
        // console.log(
        //   "typeof this.values.bank",
        //   typeof this.values.bank,
        //   this.values.bank
        // );
        // console.log(
        //   "typeof this.values.website",
        //   typeof this.values.website,
        //   this.values.website
        // );
        data = {
          email: this.values.email,
          famil: this.values.famil,
          name: this.values.name,
          otch: this.values.otch,
          position: this.values.position,
          phone: this.values.phone,
          phone_note: this.values.phone_note,
          address: this.values.address,
          bio: this.values.bio,
          date: this.values.date,
          emailContact: this.values.email,
          role: this.values.role,
          active: this.values.active,
          bank:
            typeof this.values.bank === "object"
              ? JSON.stringify(this.values.bank)
              : `[${this.values.bank}]`,
          website:
            typeof this.values.website === "object"
              ? JSON.stringify(this.values.website)
              : `[${this.values.website.replace("[", "").replace("]", "")}]`,
          onlyRead: this.values.onlyRead,
        };
        try {
          await this.$store.dispatch("addUserOfFirm2", data);
          if (this.$store.getters.getErrorApi == "EMAILNOTUNIQUE") {
            Swal.fire({
              icon: "error",
              title: "Email не уникальный",
              text:
                "Пользователь с email " +
                this.values.email +
                " уже зарегистрирован в системе.",
            });
            this.progress = false;
            this.clearBtn(clearInter);
            return;
          }
          if (this.$store.getters.getErrorApi == "OK") {
            Swal.fire({
              icon: "success",
              title: "Сохранено!",
              text: "Пользователь успешно добавлен.",
            });
            this.items = this.$store.getters.getAgentFirmSorts;
            this.progress = false;
            this.clearBtn(clearInter);
            this.close();
          }
        } catch (e) {
          this.progress = false;
          Swal.fire({
            icon: "error",
            title: "Сохранено!",
            text: "Пользователь не добавлен.",
          });
        } finally {
          this.clearBtn(clearInter);
        }
        return;
      }

      //edit save

      if (!this.values.profile_name) {
        Swal.fire({
          icon: "error",
          title: "Ошибка",
          text: "Поле 'Имя' обязательно к заполнению ",
        });
        return;
      }
      if (!this.values.emailContact) {
        Swal.fire({
          icon: "error",
          title: "Ошибка",
          text: "Поле 'Контактный Email' обязательно к заполнению ",
        });
        return;
      }

      // if (this.editedIndex > -1) {
      data = {
        ...this.values,
        id: this.values.user_id,
        famil: this.makeGoodField(this.values.famil),
        name: this.makeGoodField(this.values.profile_name),
        otch: this.makeGoodField(this.values.otch),
        position: this.makeGoodField(this.values.position),
        phone: this.makeGoodField(this.values.phone),
        phone_note: this.makeGoodField(this.values.phone_note),
        emailContact: this.values.emailContact,
        role: this.values.role,
        bank: this.values.bank,
        website: this.values.website,
        onlyRead: this.values.onlyRead,

        // email: this.values.email,
        // famil: this.values.famil,
        // name: this.values.name,
        // otch: this.values.otch,
        // position: this.values.position,
        // phone: this.values.phone,
        // phone_note: this.values.phone_note,
        // address: this.values.address,
        // bio: this.values.bio,
        // date: this.values.date,
        // emailContact: this.values.email,
        // role: this.values.role,
        // active: this.values.active,
        // bank: this.values.bank,
        // website: this.values.website,
        // onlyRead: this.values.onlyRead,
      };
      try {
        await this.$store.dispatch("updateAgentSorts", data);
        this.items = this.$store.getters.getAgentFirmSorts;
        if (this.$store.getters.getErrorApi == "ADMINFOREVER") {
          Swal.fire({
            icon: "warning",
            title: "Роль не изменилась",
            text: "Нельзя лишить себя роли администратора.",
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "удачно!",
            text: "Данные сотрудника обновлены",
          });
        }
      } finally {
        this.close();
      }
    },
    close() {
      this.$emit("close", false);
      // setTimeout(() => {
      //   this.$refs.form.resetValidation();
      // }, 300);
    },
    async getBanksInfo() {
      await this.$store.dispatch("getProductCS", 1);
      const profile = JSON.parse(localStorage.getItem("profile"), true);
      // console.log("profile", profile);
      if (profile.role === "bank" || profile.role === "bankAdmin") {
        // console.log("bank");
        this.values.bank = JSON.parse(profile.bank)[0];
        this.values.website = JSON.parse(profile.website);
        return;
      }
      if (profile.role === "agregator" || profile.role === "agregatorAdmin") {
        // console.log("agregator");
        this.values.website = JSON.parse(profile.website)[0];
        this.values.bank = JSON.parse(profile.bank);
        return;
      }

      this.values.website = JSON.parse(profile.website);
      this.values.bank = JSON.parse(profile.bank);
    },
  },
  computed: {
    values: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    product() {
      return this.$store.getters.getProductData;
    },
    roles() {
      return this.getRoles();
    },
  },
  async mounted() {
    const { data } = await this.$store.dispatch("GetCalcSettingsCS");
    // console.log('data',data);
    this.product2 = data;
    this.getBanksInfo();
  },
  watch: {
    show(val) {
      if (val) {
        this.getBanksInfo();
      }
    },
    "values.role"(newVal, oldVal) {
      // console.log("values.role", newVal);
      if (!oldVal) {
        return;
      }
      if (!newVal) {
        return;
      }
      if (newVal !== oldVal) {
        if (newVal === "bank" || newVal === "bankAdmin") {
          this.values.bank = "";
          this.values.website = [];
          this.values.onlyRead = false;
        }
        if (newVal === "agregator" || newVal === "agregatorAdmin") {
          this.values.website = "";
          this.values.bank = [];
          this.values.onlyRead = false;
        }
      }
    },
  },
};
</script>
